export default "__VITE_ASSET__ko7Cmjk9__"